import React from "react";
import { Box, Typography } from "@material-ui/core";
import TranslatedMaterialTable from "../../../shared/TranslatedMaterialTable";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useRequest from "../../../utils/hook/requestHook";
import { WebUser } from "../../../models/WebUser";
import { post } from "../../../api";
import { REFRESH_ACCOUNT_BY_TOKEN } from "../../../api/apiRoutes";

const BalanceTab: React.FC = () => {
  const { token } = useSelector((state: State) => state.auth.webUser);
  const [data] = useRequest<WebUser>(async () => await post(REFRESH_ACCOUNT_BY_TOKEN, { token }));
  return (
    <Box my={3} style={{ width: "100%" }}>
      <TranslatedMaterialTable
        onRowClick={() => {}}
        options={{
          search: false,
        }}
        title={``}
        isLoading={false}
        columns={[
          {
            title: `${data?.descriptionBalanceI}`,
            field: "balanceI",
            render: (row: any) => <Typography dangerouslySetInnerHTML={{ __html: row.balanceI }} />,
          },
          {
            title: `${data?.descriptionBalanceII}`,
            field: "balanceII",
            render: (row: any) => <Typography dangerouslySetInnerHTML={{ __html: row.balanceII }} />,
          },
          {
            title: `${data?.descriptionBalanceIII}`,
            field: "balanceIII",
            render: (row: any) => <Typography dangerouslySetInnerHTML={{ __html: row.balanceIII }} />,
          },
          {
            title: `${data?.descriptionDepositBalance}`,
            field: "balanceIV",
            render: (row: any) => <Typography dangerouslySetInnerHTML={{ __html: row.balanceIV }} />,
          },
        ]}
        data={[
          {
            balanceI: data?.captionBalanceI,
            balanceII: data?.captionBalanceII,
            balanceIII: data?.captionBalanceIII,
            balanceIV: data?.captionDepositBalance,
          },
        ]}
      />
    </Box>
  );
};

export default BalanceTab;
